export default __webpack_public_path__ + "static/media/dining.31facad6.svg";